import React from 'react'
import { Collapse as CollapseBase, Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'
import {
  AccountBalanceOutlined as AccountBalanceOutlinedBase,
  CategoryOutlined as CategoryOutlinedBase,
  InboxOutlined as InboxOutlinedBase,
  ShoppingCartOutlined as ShoppingCartOutlinedBase,
  ExpandMore as ExpandMoreBase
} from '@mui/icons-material'
import { Link as LinkBase } from 'react-router-dom'

export const Root = styled('div')`
  background-size: cover !important;
  background-color: ${props => props.theme.palette.charts.gray};
  background-image: url('/assets/images/agilePurchaseTradedProducts.svg');
  background-position: center;
  width: 100%;
`

export const CardCollapse = styled(CollapseBase)``

export const CardCollapseIcon = styled(({ open, ...props }) => <ExpandMoreBase {...props} />)`
  &.MuiSvgIcon-root {
    cursor: pointer;
    fill: ${props => props.theme.palette.brand.black3};
    transform: ${props => (props.open ? 'rotate(180deg)' : 'rotate(0)')};
    width: 24px;
    height: 24px;
  }
`
export const CardTitle = styled('h3')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  margin: 0;
`
export const Content = styled(({ margin, padding, ...props }) => <ContainerBase container {...props} />)`
  &.MuiContainer-root {
    padding: 64px 32px;
  }
  ${props => props.theme.breakpoints.up('sm')} {
    &.MuiContainer-root {
      padding:  38px 40px;
    }
`

export const GridContainer = styled(({ margin, padding, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ margin, padding, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.charts.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: 700;
  font-size: 34px;
  line-height: 38px;
  letter-spacing: 0.2px;
  margin: 0;
  padding: 0 0 28px;
`

export const Description = styled('p')`
  color: ${props => props.theme.palette.charts.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  margin: 0;
  padding: 0 0 28px;
`

export const SegmentIcon = styled(AccountBalanceOutlinedBase)`
  display: block;
  height: 15px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 15px;

  &.MuiSvgIcon-root {
    font-size: 1rem;
  }
`

export const FamilyIcon = styled(InboxOutlinedBase)`
  display: block;
  height: 15px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 15px;

  &.MuiSvgIcon-root {
    font-size: 1rem;
  }
`

export const CategoryIcon = styled(CategoryOutlinedBase)`
  display: block;
  height: 15px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 15px;

  &.MuiSvgIcon-root {
    font-size: 1rem;
  }
`

export const ProductIcon = styled(ShoppingCartOutlinedBase)`
  display: block;
  height: 15px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 15px;

  &.MuiSvgIcon-root {
    font-size: 1rem;
  }
`
export const SectionDivider = styled('hr')`
  height: 1px;
  background-color: ${props => props.theme.palette.brand.gray2};
  border: none;
`
export const Link = styled(LinkBase)`
  color: ${props => props.theme.palette.brand.primary};
  font-size: 14px;
  text-decoration: none;
`
export const InfoLabel = styled('div')`
  color: ${props => props.theme.palette.brand.black3};
  display: inline-block;
  zoom: 1;
  margin: ${props => props.margin};
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-style: italic;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0px;
  white-space: pre-line;
`
